import { AssetTypeFieldValuesAttachmentService as OvermapAssetTypeFieldValuesAttachmentService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class AssetTypeFieldValuesAttachmentService extends OvermapAssetTypeFieldValuesAttachmentService<
	RootState,
	AppSDK
> {
	host = import.meta.env.REACT_APP_API_URL
}
